import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {InventoryFieldDTO} from "../../../services/api/api";

@Component({
  selector: 'app-inventory-scope-select',
  templateUrl: './inventory-scope-select.component.html',
  styleUrls: ['./inventory-scope-select.component.scss'],
  standalone: false,
})
export class InventoryScopeSelectComponent implements OnInit {
  constructor(public translate: TranslateService) {}

  @Input() currentSelection: InventoryFieldDTO;
  @Input() inventoryFields: InventoryFieldDTO[];
  @Output() selectionChange: EventEmitter<InventoryFieldDTO> = new EventEmitter<InventoryFieldDTO>();
  cleanedSelection: InventoryFieldDTO[];

  ngOnInit(): void {}
}
